import { ExpandMore } from '@mui/icons-material';
import { IconButton, Stack, type SxProps, type Theme, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import settings from '/@/core/settings';
import { useToggle } from '/@/hooks/toggle/useToggle';
import useIsMobile from '/@/utils/hooks/is-mobile';

const CropMonitoringDetailCard = ({
    title,
    subtitle,
    children,
    sx,
    ...props
}: {
    title: string;
    subtitle?: string;
    children?: ReactNode;
    sx?: SxProps<Theme>;
}) => {
    const isMobile = useIsMobile();

    const { toggle, open } = useToggle(true);

    return (
        <Stack
            sx={[
                settings.app.theme === 'expertobayer'
                    ? {
                          border: '1px solid #e5e7eb',
                      }
                    : {
                          boxShadow: { md: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px' },
                          borderRadius: 4,
                          border: { xs: 1, md: 0 },
                          borderColor: (t) => t.palette.divider,
                          background: { md: 'white' },
                      },
                sx,
            ]}
            {...props}
        >
            <Stack
                direction='row'
                sx={[(!isMobile || (isMobile && open)) && { borderBottom: '1px solid #E1E1E1' }]}
                px={2}
                py={1.5}
                justifyContent={'space-between'}
                alignItems='center'
            >
                <Stack spacing={0.5}>
                    <Typography
                        color='primary'
                        variant='h6'
                        sx={{
                            fontWeight: 500,
                        }}
                    >
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography color='primary.mui.inactive' variant='body2'>
                            {subtitle}
                        </Typography>
                    )}
                </Stack>

                {isMobile && (
                    <IconButton onClick={() => toggle()} sx={{ mr: -1.5 }}>
                        <ExpandMore
                            fontSize='large'
                            sx={[
                                open && {
                                    transform: 'rotate(180deg)',
                                },
                            ]}
                        />
                    </IconButton>
                )}
            </Stack>
            {((isMobile && open) || !isMobile) && children}
        </Stack>
    );
};

export default CropMonitoringDetailCard;
